import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'terms' | 'privacy' | 'contact' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const openModal = (type: ModalType) => setActiveModal(type);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-dark text-white py-12 px-4" data-id="element-74">
        <div className="max-w-4xl mx-auto text-center" data-id="element-75">
          <h3 className="font-serif text-2xl mb-4" data-id="element-76">
            Vitarutinas - Sistema Mamá IA
          </h3>

          <div className="flex flex-wrap justify-center gap-6 mb-6" data-id="element-77">
            <button onClick={() => openModal('terms')} className="text-sm hover:text-primary transition-colors" data-id="element-78">
              Términos y Condiciones
            </button>
            <button onClick={() => openModal('privacy')} className="text-sm hover:text-primary transition-colors" data-id="element-79">
              Política de Privacidad
            </button>
            <button onClick={() => openModal('contact')} className="text-sm hover:text-primary transition-colors" data-id="element-80">
              Contacto
            </button>
          </div>

          <p className="text-sm text-gray-400 mb-2" data-id="element-81">
            © 2024 Vitarutinas. Todos los derechos reservados.
          </p>

          <p className="text-xs text-gray-500 mb-4" data-id="element-82">
            Contacto:{' '}
            <a href="mailto:contacto@vitarutinas.com" className="hover:text-primary transition-colors" data-id="element-83">
              contacto@vitarutinas.com
            </a>
          </p>

          <p className="text-xs text-gray-500" data-id="element-84">
            Este sitio no es parte de Facebook o Meta Platforms, Inc. Además,
            este sitio NO está respaldado por Facebook de ninguna manera.
            FACEBOOK es una marca registrada de Meta Platforms, Inc.
          </p>
        </div>
      </footer>

      {/* Modals */}
      <AnimatePresence data-id="element-85">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={closeModal} className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-id="element-86">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} onClick={e => e.stopPropagation()} className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 relative" data-id="element-87">
              <button onClick={closeModal} className="absolute top-4 right-4 text-gray-500 hover:text-dark" data-id="element-88">
                <X className="w-6 h-6" data-id="element-89" />
              </button>

              {activeModal === 'terms' && <>
                  <h2 className="font-serif text-3xl text-dark mb-6" data-id="element-90">
                    Términos y Condiciones
                  </h2>
                  <div className="text-body space-y-4" data-id="element-91">
                    <p data-id="element-92">Última actualización: Enero 2024</p>

                    <h3 className="font-bold text-dark text-xl mt-6" data-id="element-93">
                      1. Aceptación de los Términos
                    </h3>
                    <p data-id="element-94">
                      Al acceder y utilizar Sistema Mamá IA, aceptas estar
                      sujeto a estos términos y condiciones.
                    </p>

                    <h3 className="font-bold text-dark text-xl mt-6" data-id="element-95">
                      2. Descripción del Servicio
                    </h3>
                    <p data-id="element-96">
                      Sistema Mamá IA es un producto digital educativo que
                      proporciona guías, prompts y recursos para crear productos
                      digitales utilizando inteligencia artificial.
                    </p>

                    <h3 className="font-bold text-dark text-xl mt-6" data-id="element-97">
                      3. Uso del Producto
                    </h3>
                    <p data-id="element-98">
                      El contenido proporcionado es solo para uso personal y
                      educativo. No está permitida la reventa o distribución del
                      material sin autorización expresa.
                    </p>

                    <h3 className="font-bold text-dark text-xl mt-6" data-id="element-99">
                      4. Propiedad Intelectual
                    </h3>
                    <p data-id="element-100">
                      Todo el contenido, incluyendo textos, gráficos, logos y
                      software, es propiedad de Vitarutinas y está protegido por
                      leyes de derechos de autor.
                    </p>

                    <h3 className="font-bold text-dark text-xl mt-6" data-id="element-101">
                      5. Limitación de Responsabilidad
                    </h3>
                    <p data-id="element-102">
                      Los resultados individuales pueden variar. No garantizamos
                      ingresos específicos ni resultados particulares del uso de
                      nuestro sistema.
                    </p>

                    <h3 className="font-bold text-dark text-xl mt-6" data-id="element-103">
                      6. Política de Reembolso
                    </h3>
                    <p data-id="element-104">
                      Debido a la naturaleza digital del producto, no ofrecemos
                      reembolsos una vez que se ha proporcionado el acceso al
                      contenido.
                    </p>
                  </div>
                </>}

              {activeModal === 'privacy' && <>
                  <h2 className="font-serif text-3xl text-dark mb-6" data-id="element-105">
                    Política de Privacidad
                  </h2>
                  <div className="text-body space-y-4" data-id="element-106">
                    <p data-id="element-107">Última actualización: Enero 2024</p>

                    <h3 className="font-bold text-dark text-xl mt-6" data-id="element-108">
                      1. Información que Recopilamos
                    </h3>
                    <p data-id="element-109">
                      Recopilamos información personal que nos proporcionas
                      voluntariamente, incluyendo nombre, correo electrónico y
                      datos de pago.
                    </p>

                    <h3 className="font-bold text-dark text-xl mt-6" data-id="element-110">
                      2. Uso de la Información
                    </h3>
                    <p data-id="element-111">
                      Utilizamos tu información para procesar pedidos, enviar el
                      producto digital, proporcionar soporte al cliente y enviar
                      comunicaciones relacionadas con el producto.
                    </p>

                    <h3 className="font-bold text-dark text-xl mt-6" data-id="element-112">
                      3. Protección de Datos
                    </h3>
                    <p data-id="element-113">
                      Implementamos medidas de seguridad para proteger tu
                      información personal contra acceso no autorizado,
                      alteración o destrucción.
                    </p>

                    <h3 className="font-bold text-dark text-xl mt-6" data-id="element-114">
                      4. Cookies y Tecnologías de Seguimiento
                    </h3>
                    <p data-id="element-115">
                      Utilizamos cookies y tecnologías similares, incluyendo
                      Meta Pixel, para mejorar tu experiencia y analizar el uso
                      del sitio.
                    </p>

                    <h3 className="font-bold text-dark text-xl mt-6" data-id="element-116">
                      5. Compartir Información
                    </h3>
                    <p data-id="element-117">
                      No vendemos ni alquilamos tu información personal a
                      terceros. Podemos compartir información con proveedores de
                      servicios que nos ayudan a operar nuestro negocio.
                    </p>

                    <h3 className="font-bold text-dark text-xl mt-6" data-id="element-118">
                      6. Tus Derechos
                    </h3>
                    <p data-id="element-119">
                      Tienes derecho a acceder, corregir o eliminar tu
                      información personal. Contáctanos para ejercer estos
                      derechos.
                    </p>
                  </div>
                </>}

              {activeModal === 'contact' && <>
                  <h2 className="font-serif text-3xl text-dark mb-6" data-id="element-120">
                    Contacto
                  </h2>
                  <div className="text-body space-y-4" data-id="element-121">
                    <p data-id="element-122">
                      ¿Tienes preguntas o necesitas ayuda? Estamos aquí para ti.
                    </p>

                    <div className="bg-gray-50 p-6 rounded-lg mt-6" data-id="element-123">
                      <h3 className="font-bold text-dark text-xl mb-4" data-id="element-124">
                        Información de Contacto
                      </h3>
                      <p className="mb-2" data-id="element-125">
                        <strong data-id="element-126">Email:</strong>{' '}
                        <a href="mailto:contacto@vitarutinas.com" className="text-primary hover:underline" data-id="element-127">
                          contacto@vitarutinas.com
                        </a>
                      </p>
                      <p className="mb-2" data-id="element-128">
                        <strong data-id="element-129">Tiempo de respuesta:</strong> 24-48 horas
                        hábiles
                      </p>
                    </div>

                    <p className="mt-6" data-id="element-130">
                      Nuestro equipo de soporte está comprometido a ayudarte con
                      cualquier pregunta sobre el producto, acceso al contenido
                      o problemas técnicos que puedas experimentar.
                    </p>

                    <p data-id="element-131">
                      Para consultas sobre pedidos, por favor incluye tu número
                      de orden en el correo electrónico para que podamos
                      asistirte más rápidamente.
                    </p>
                  </div>
                </>}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}